module.exports = __webpack_public_path__ + "static/media/windows.bbc12c45.svg";